import React, { useState, useEffect } from 'react';
import HeaderMobile from './HeaderMobile.js';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import Footer from './Footer.js';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from "./Constants.js";

const Add_Area = () => {
  const [formData, setFormData] = useState({ area: '' });
  const [formError, setFormError] = useState(null);
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [user, setUser] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    const fetchProfile = async () => {
      try {
        const response = await fetch(`${BASE_URL}profile`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        const data = await response.json();
        setUser(data.profile.is_uniform_access_given);
      } catch (error) {
        setError(error.message);
        console.error('Error fetching profile:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.area.trim()) {
      setFormError('Area field is required.');
      return;
    }

    try {
      const token = localStorage.getItem('authToken');
      const data = new FormData();
      data.append('area', formData.area.trim());

      const response = await fetch(`${BASE_URL}add_area`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        body: data,
      });

      const result = await response.json();

      if (!result.status) {
        throw new Error(result.message || 'Failed to add area');
      }

      navigate('/manage_areas');
    } catch (err) {
      setFormError(err.message);
    }
  };
  const handleToggleSidebar = () => {
    if (window.innerWidth >= 992) {
      setIsSidebarOpen(prev => !prev);
    }
  };
  const handleCancel = () => {
    navigate('/manage_areas');
  }
  return (
    <div className="page-wrapper">
      <HeaderMobile />
      <Sidebar isOpen={isSidebarOpen} />
      <div className="page-container">
      <Header onToggleSidebar={handleToggleSidebar} isSidebarOpen={isSidebarOpen}/>
        <div className="main-content">
          <div className="section__content section__content--p30">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-6 offset-lg-3">
                  <div className="card">
                    <div className="card-header">
                      <h2>Add New Area</h2>
                    </div>
                    <div className="card-body">
                      <form onSubmit={handleSubmit}>
                        {formError && <div className="alert alert-danger">{formError}</div>}
                        <div className="form-group">
                          <label htmlFor="area">Area</label>
                          <input
                            type="text"
                            id="area"
                            name="area"
                            className="form-control"
                            value={formData.area}
                            onChange={handleInputChange}
                          />
                        </div>
                        <div style={{ display: 'flex', gap: '10px' }}>
                        <button type="submit" className="btn btn-primary">
                          Submit
                        </button>
                        <button type="button" className="btn btn-secondary" onClick={handleCancel}>
                            Cancel
                          </button>
                          </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Add_Area;
